import WizardRegistrationWelcome from './container'
export { WizardRegistrationWelcome }
export default WizardRegistrationWelcome